import $ from 'jquery';
import Barba from 'barba.js';

import Home from './home';
import Single from './single';
import Slider from './slider';
import Recaptcha from './Recaptcha';

export default class Features {
    constructor() {
        this.colorArray = [
            '#7ed6cc',
            '#fd8282',
            '#ffd861',
            '#63b0f0'
        ];

        /*
        * Validation formualaire recherche
        */
        $('#search-content #search').submit(event => {
            event.preventDefault();

            this.appSearch($('#search-content #input-search').val());
        });

        $('#search-content #input-search').on('input', event => {
            this.appSearch($(event.target).val());
        });

        /*
        * Ouverture recherche
        */
        $(document).on('click', 'nav #search-btn', function () {
            $(document.documentElement).css('overflow', 'hidden');
            $('#search-content').fadeIn(600);
            $('#input-search').focus();
        });

        /*
        * Ouverture listing tags
        */
        $(document).on('click', 'nav #tag-btn', (e) => {
            $(document.documentElement).css('overflow', 'hidden');
            $('#tags-content .valign .tags li').each(function () {
                $(this).css('transition-delay', Math.random(.2, 2.3) + 's');
            });

            const elt = $('#tags-content .valign .list > div');

            elt.each(e => this.splitText(elt.eq(e), 0));

            clearInterval(this.tagInterval);

            var tagIdx = 0;
            $('#tags-content .valign .list > div').eq(tagIdx).addClass('visible');
            this.tagInterval = setInterval(function () {
                $('#tags-content .valign .list > div').removeClass('visible');
                setTimeout(function () {
                    $('#tags-content .valign .list > div').eq(tagIdx).addClass('visible');
                }, 300);
                if (tagIdx < $('#tags-content .valign .list > div').length - 1) {
                    tagIdx++;
                } else {
                    tagIdx = 0;
                }
            }, 3000);

            $('#tags-content').fadeIn(600).addClass('visible');
        });

        /*
        * Fermeture recherche, listing tags
        */
        $(document).on('click', 'aside .close', function () {
            $(this).parent().fadeOut(600).removeClass('visible');
            $(document.documentElement).css('overflow', '');

            if ($(this).parent().attr('id') === 'tags-content') {
                $('#tags-content .valign .list > div').removeClass('visible').eq(0).addClass('visible');
                clearInterval(this.tagInterval);
            }
        });

        /*
        * Reset overflow clic lien menu #
        */
        $(document).on('click', '#tags-content a', function () {
            $(document.documentElement).css('overflow', '');
        });

        /*
        * Fermeture de la popup recherche au clic sur un résultat
        */

        $(document).on('click', '#search-content .valign .result-container article a', function () {
            $('#search-content .close').trigger('click');
            $(document.documentElement).css('overflow', '');
        });

        $(document).on('submit', 'section #comments form', function (event) {
            event.preventDefault();

            var form = $(this);

            $.ajax({
                url: '/wp-json/wp/v2/comments',
                method: 'post',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({
                    author_name: form.find('#author').val(),
                    author_email: form.find('#email').val(),
                    content: form.find('#comment').val(),
                    post: form.find('#comment_post_ID').val(),
                    parent: form.find('#comment_parent').val()
                })
            }).done(function (comment) {
                $('section .popin').fadeIn().find('.container').html('<p>Merci pour votre contribution ' + comment.author_name + ' ! <br />Votre commentaire est en cours de modération et sera visible très prochainement.</p>');
                $('section #comments form #comment_parent').val('');
                $('section #comments form fieldset #author').val('');
                $('section #comments form fieldset #email').val('');
                $('section #comments form fieldset #comment').val('');
                setTimeout(function () {
                    $('section .popin').fadeOut().find('.container').html('');
                }, 4000);
            }).fail(function (comment) {
                alert(comment.message);
            });
        });

        $(document).on('click', '.toggle-tarte-citron', () => {
            $('#tarteaucitron').show();
        });

        const figureCaption = document.querySelector('.wp-caption');

        if (figureCaption){
            if (figureCaption.children[0].classList.contains('w-100')){
                figureCaption.classList.add('w-100');
            }
        }
    }

    init() {
        if ($('body').hasClass('home')) {
            new Home();
        }
        if ($('body').hasClass('single') || $('body').hasClass('page-template-gabarit-job')) {
            new Single();
        }

        if ($('body').hasClass('category')) {
            this.colors('.content .category-content article', 0, 0);

            $('#section-images a').first().addClass('active').parent().css('background', $('.category-content .content article:first-child > a').data('color'));
        }

        if ($('.stacked-slider').length > 0) {
            new Slider();
        }

        if ($('body').hasClass('archive')) {
            this.colors('.content article', 0, 0);
        }

        this.recaptcha();
    }

    recaptcha() {
        Recaptcha.ready.then(grecaptcha => {
            $('.g-recaptcha').each((index, element) => {
                grecaptcha.render(element, element.dataset);
            });
        });
    }

    barba() {
        var getBodyClass,
            bodyClasses,
            getColor;

        Barba.Pjax.start();

        Barba.Dispatcher.on('linkClicked', function (el, e) {

            /*
            * Click sur lien dans listing tags
            */
            if ($(el).hasClass('fade-parent')) {
                setTimeout(function () {
                    $('#tags-content').fadeOut(600);
                }, 400);
            }

            var colorArray = [
                '#7ed6cc',
                '#fd8282',
                '#ffd861',
                '#63b0f0'
            ];

            /*
            * Attribution classe en fonction de l'index de l'élément cliqué
            */
            switch ($(el).attr('data-color')) {
                case colorArray[0]:
                    getColor = 'vert';
                    break;

                case colorArray[1]:
                    getColor = 'rouge';
                    break;

                case colorArray[2]:
                    getColor = 'jaune';
                    break;

                case colorArray[3]:
                    getColor = 'bleu';
                    break;

                default:
                    getColor = '';
                    break;
            }
        });

        Barba.Dispatcher.on('newPageReady', function (currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
            getBodyClass = newPageRawHTML.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', newPageRawHTML),
                bodyClasses = $(getBodyClass).filter('notbody').attr('class');

            $('body').addClass(getColor);
            $('nav #search-btn svg, nav #tag-btn svg, footer .rs a').removeAttr('style');
        });

        var customTransiton = Barba.BaseTransition.extend({
            start: function () {
                Promise
                    .all([this.newContainerLoading, this.fadeContent()])
                    .then(this.fadeIn.bind(this));

                return false;
            },
            fadeContent: function () {
                return $(this.oldContainer).animate({opacity: 0}, 400).promise();
            },
            fadeIn: function () {
                var _this = this,
                    $el = $(this.newContainer),
                    _loader = $('#loader-transition'),
                    getTags,
                    getTitle;

                $(this.oldContainer).hide();

                $el.css({
                    visibility: 'visible',
                    opacity: 0
                });

                if (bodyClasses.indexOf('home') !== -1) {
                    getTags = '';
                    getTitle = '<em>Zeste !</em> by Couleur Citron';
                } else if (bodyClasses.indexOf('category') !== -1) {
                    getTags = '';
                    getTitle = $el.find('.row > header .tags li a').html();
                } else {
                    getTags = $el.find('.row > header .tags').html();
                    getTitle = $el.find('.row > header h1').html();
                }

                _loader.find('.content .tags').html(getTags);
                _loader.find('.content .title').html(getTitle);

                _loader.fadeIn(450, function () {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 20);

                    $el.animate({opacity: 1}, 20, function () {
                        _this.done();
                        $('body').attr('class', bodyClasses + ' ' + getColor);
                    });

                    setTimeout(function () {
                        _loader.fadeOut(450);
                    }, 1500);
                });
            }
        });

        Barba.Pjax.getTransition = function () {
            return customTransiton;
        };

        Barba.Dispatcher.on('transitionCompleted', (e) => {
            this.init();
        });
    }

    splitText(element, time) {
        var obj = element,
            text = obj.text(),
            sentence,
            parsed = '';

        sentence = text.split(' ');
        obj.empty();
        for (var word in sentence) {
            var wordTag = document.createElement('span');
            wordTag.className = 'word';
            wordTag.innerHTML = sentence[word] + ' ';
            obj.append(wordTag);
        }

        element.find('.word').each(function () {
            var getWord = $(this),
                getLetter = getWord.text(),
                someLetter = getLetter.split('');

            getWord.empty();
            for (var letter in someLetter) {
                var addSpan = document.createElement('span');
                addSpan.className = 'letter';
                addSpan.innerHTML = someLetter[letter];
                getWord.append(addSpan);
            }
        });

        var cpt = 0;
        element.find('.word').each(function () {
            $(this).find('.letter').each(function () {
                var formattedNumber = ('0' + cpt * 3).slice(-2);
                $(this).css('transition-delay', time + '.' + formattedNumber + 's');
                cpt++;
            });
        });
    }

    colors(element, offset, elt) {
        $(element).each((e) => {
            $(element).eq(e)[0].children[elt].dataset.color = this.colorArray[($(element).eq(e).index() + offset) % 4];
        });
    }

    appSearch(query) {
        var searchQueries = new Map();

        var searchContent = $('#search-content'),
            articlesContainer = searchContent.find('> div .result-container');

        if (!query) {
            articlesContainer.empty();
            searchContent.removeClass('searched');
            return;
        }

        // If we already have the search result in cache, use it
        if (searchQueries.has(query)) {
            searchContent.addClass('searched');
            articlesContainer.html(searchQueries.get(query).response);
            return;
        }

        searchQueries.set(query, {
            timestamp: performance.now(), // Get accurate timestamp
            response: ''
        });

        $.get('/', {s: query})
            .done(function (response) {
                searchQueries.get(query).response = response;
                var maxTimestamp = Math.max.apply(null, Array.from(searchQueries.values()).map(function (searchObject) {
                    return searchObject.timestamp;
                }));
                // If this is the last search, show results
                if (searchQueries.get(query).timestamp === maxTimestamp) {
                    searchContent.addClass('searched');
                    articlesContainer.html(response);
                }
            })
            .fail(function () {
                alert("error");
            });
    }

    getRandom(min, max) {
        return Math.random() * (max - min) + min;
    }
}